<template>
    <section class="section">
      <div class="columns is-centered">
        <div class="column">
          <h3 class="title is-4 level">
            <div class="level-left">
              <div class="level-item">
                <span>{{ $t('settings.title') }}</span>
              </div>
            </div>
          </h3>
          <div class="tabs is-centered is-boxed is-medium">
            <ul>
              <li v-bind:class="{'is-active': tabs.shopActive}" @click="changeTab">
                <a>
                  <span>{{ $t('settings.texts.shopTab') }}</span>
                </a>
              </li>
              <li v-bind:class="{'is-active': tabs.userActive}" @click="changeTab">
                <a>
                  <span>{{ $t('settings.texts.userTab') }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div v-bind:class="{'is-hidden': tabs.userActive}">
            <div class="columns is-centered">
              <div class="column is-one-third">
                <div class="block">
                  <p><b>{{ $t('settings.fields.name') }}</b></p>
                  <p>{{ accountDetailsInfo.shopName }}</p>
                  <p class="help">{{ $t('settings.fields.nameHelper') }}</p>
                </div>
                <div class="field">
                  <label class="label">{{ $t('settings.fields.email') }}</label>
                  <p class="control has-icons-left has-icons-right">
                    <input
                      class="input"
                      type="email"
                      placeholder="Email"
                      value="accountDetailsInfo.email"
                      v-model="accountDetailsInfo.email"
                      @blur="validateEmail"
                      v-bind:class="{
                        'is-danger': (errors && !accountDetailsInfo.email) || failureNotification == 'onboarding.accountDetails.invalidEmailAddress',
                      }"/>
                    <span class="icon is-small is-left">
                      <i class="fa fa-envelope"></i>
                    </span>
                    <span class="icon is-small is-right" v-if="false">
                      <i class="fa fa-check"></i>
                    </span>
                  </p>
                  <p class="help">
                    {{ $t('settings.fields.emailHelper') }}
                  </p>
                  <p class="help is-danger"
                      v-if="failureNotification"
                    >
                    {{ $t(failureNotification)}}
                  </p>
                </div>
                <div class="field">
                  <label class="label">{{ $t('settings.fields.minCart') }}</label>
                  <div class="control has-icons-left">
                    <div class="select" v-bind:class="{
                          'is-danger': errors && !accountDetailsInfo.minCart,
                        }">
                      <select v-model="accountDetailsInfo.minCart">
                        <option :value="accountDetailsInfo.minCart" selected hidden>{{accountDetailsInfo.minCart}} EUR</option>
                        <option value="10">10 EUR</option>
                        <option value="20">20 EUR</option>
                        <option value="50">50 EUR</option>
                        <option value="100">100 EUR</option>
                      </select>
                    </div>
                      <span class="icon is-small is-left">
                        <i class="fa fa-shopping-cart"></i>
                      </span>
                  </div>
                  <p class="help">
                    {{ $t('settings.fields.minCartHelper') }}
                  </p>
                </div>
                <div class="field">
                  <label class="label">{{ $t('settings.fields.timeShipment') }}</label>
                  <div class="control has-icons-left">
                    <div class="select">
                      <select v-model="accountDetailsInfo.shipTime">
                        <option value=""></option>
                        <option value="1">{{ $t('settings.fields.timeShipmentValueA') }}</option>
                        <option value="2">{{ $t('settings.fields.timeShipmentValueB') }}</option>
                        <option value="3">{{ $t('settings.fields.timeShipmentValueC') }}</option>
                        <option value="4">{{ $t('settings.fields.timeShipmentValueD') }}</option>
                        <option value="5">{{ $t('settings.fields.timeShipmentValueE') }}</option>
                      </select>
                    </div>
                      <span class="icon is-small is-left">
                        <i class="fa fa-truck"></i>
                      </span>
                  </div>
                  <p class="help">
                    {{ $t('settings.fields.timeShipmentHelper') }}
                  </p>
                </div>
                <div class="field">
                  <p class="control">
                    <primary-button :label="$t('app.buttons.save')" @click="submitShop()" :loading="submittingShop"></primary-button>
                  </p>
                  <p class="help" v-if="saved == true">
                    {{ $t('app.messages.saved') }}
                  </p>
                  <p v-if="saved == false">
                    {{ $t('app.messages.failedSaving') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-bind:class="{'is-hidden': tabs.shopActive}">
            <div class="columns is-centered">
              <div class="column is-one-third">
                <div class="block">
                  <div class="field">
                    <label class="label">{{ $t('settings.fields.security') }}</label>
                    <Modal buttonClass="button" :buttonLabel="$t('settings.fields.changePassword')">
                      <div class="columns is-centered">
                        <div class="block">
                          <div class="field">
                            <label class="label">{{ $t('settings.fields.oldPassword') }}</label>
                            <p class="control has-icons-left has-icons-right">
                              <input
                                class="input"
                                :type="passwordFieldType"
                                placeholder=""
                                v-focus
                                v-model="accountDetailsInfo.oldPassword"
                                v-bind:class="{
                                  'is-danger': errors && !accountDetailsInfo.oldPassword,
                                }"
                                @change="onLoginInfoChanged"
                              />
                              <span class="icon is-small is-left">
                                <i class="fa fa-lock"></i>
                              </span>
                              <span class="icon is-small is-right">
                                <i v-bind:class="{
                                  'fa': true,
                                  'fa-eye': !showPassword,
                                  'fa-eye-slash': showPassword
                                  }"
                                  style="pointer-events: all; cursor: pointer"
                                  @click="showHidePassword()">
                                </i>
                              </span>
                            </p>
                            <p class="help"
                              v-if="errors && accountDetailsInfo.wrongCurrentPassword"
                              v-bind:class="{
                                'is-danger': errors && accountDetailsInfo.wrongCurrentPassword,
                              }"
                            >
                              {{ $t('settings.fields.passwordErrorMatch') }}
                            </p>
                          </div>
                          <div class="field">
                            <label class="label">{{ $t('settings.fields.newPassword') }}</label>
                            <p class="control has-icons-left has-icons-right">
                              <input
                                class="input"
                                :type="passwordFieldType"
                                placeholder=""
                                v-focus
                                v-model="accountDetailsInfo.newPassword"
                                v-bind:class="{
                                  'is-danger': errors && (!accountDetailsInfo.newPassword || !validPassword),
                                }"
                                @change="onLoginInfoChanged"
                              />
                              <span class="icon is-small is-left">
                                <i class="fa fa-lock"></i>
                              </span>
                              <span class="icon is-small is-right">
                                <i v-bind:class="{
                                  'fa': true,
                                  'fa-eye': !showPassword,
                                  'fa-eye-slash': showPassword
                                  }"
                                  style="pointer-events: all; cursor: pointer"
                                  @click="showHidePassword()">
                                </i>
                              </span>
                            </p>
                            <p class="help"
                              v-if="errors && !validPassword"
                              v-bind:class="{
                                'is-danger': errors && !validPassword,
                              }"
                            >
                              {{ $t('settings.fields.passwordErrorCriteria') }}
                            </p>
                          </div>
                          <div class="field">
                            <label class="label">{{ $t('settings.fields.passwordRepeat') }}</label>
                            <p class="control has-icons-left has-icons-right">
                              <input
                                class="input"
                                :type="passwordFieldType"
                                placeholder=""
                                v-focus
                                v-model="accountDetailsInfo.repeatPassword"
                                v-bind:class="{
                                  'is-danger': errors && !accountDetailsInfo.repeatPassword,
                                }"
                                @change="onLoginInfoChanged"
                              />
                              <span class="icon is-small is-left">
                                <i class="fa fa-lock"></i>
                              </span>
                              <span class="icon is-small is-right">
                                <i v-bind:class="{
                                  'fa': true,
                                  'fa-eye': !showPassword,
                                  'fa-eye-slash': showPassword
                                  }"
                                  style="pointer-events: all; cursor: pointer"
                                  @click="showHidePassword()">
                                </i>
                              </span>
                            </p>
                            <p class="help"
                              v-if="(errors && accountDetailsInfo.newPassword !== accountDetailsInfo.repeatPassword)"
                              v-bind:class="{
                                'is-danger': errors && accountDetailsInfo.newPassword !== accountDetailsInfo.repeatPassword
                              }"
                            >
                              {{ $t('settings.fields.passwordRepeatErrorMatch') }}
                            </p>
                          </div>
                          <div class="field">
                            <p class="control">
                              <primary-button :label="$t('app.buttons.save')" @click="submitPassword()" :loading="submittingPassword"></primary-button>
                            </p>
                            <p class="help" v-if="saved == true">
                              {{ $t('app.messages.saved') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-centered">
              <div class="column is-one-third">
                <div class="block">
                  <div class="field">
                    <label class="label">{{ $t('settings.fields.ownerName') }}</label>
                    <p class="control has-icons-left has-icons-right">
                      <input
                        class="input"
                        type="text"
                        placeholder=""
                        v-focus
                        v-model="accountDetailsInfo.ownerName"
                        v-bind:class="{
                          'is-danger': errors && !accountDetailsInfo.ownerName,
                        }"
                      />
                      <span class="icon is-small is-left">
                        <i class="fa fa-user"></i>
                      </span>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('settings.fields.ownerSurname') }}</label>
                    <p class="control has-icons-left has-icons-right">
                      <input
                        class="input"
                        type="text"
                        value="accountDetailsInfo.ownerSurname"
                        placeholder=""
                        v-model="accountDetailsInfo.ownerSurname"
                        v-bind:class="{
                          'is-danger': errors && !accountDetailsInfo.ownerSurname,
                        }"
                      />
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('settings.fields.address') }}</label>
                    <p class="control has-icons-left has-icons-right">
                      <input
                        class="input"
                        type="text"
                        value="accountDetailsInfo.address"
                        placeholder=""
                        v-model="accountDetailsInfo.address"
                        v-bind:class="{
                          'is-danger': errors && !accountDetailsInfo.address,
                        }"
                      />
                      <span class="icon is-small is-left">
                        <i class="fa fa-address-card"></i>
                      </span>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">{{ $t('settings.fields.phone') }}</label>
                    <p class="control has-icons-left has-icons-right">
                      <input
                        class="input"
                        type="text"
                        value="accountDetailsInfo.phone"
                        placeholder=""
                        v-model="accountDetailsInfo.phone"
                        v-bind:class="{
                          'is-danger': errors && !accountDetailsInfo.phone,
                        }"
                      />
                      <span class="icon is-small is-left">
                        <i class="fa fa-phone"></i>
                      </span>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control">
                      <primary-button :label="$t('app.buttons.save')" @click="submitUser()" :loading="submittingUser"></primary-button>
                    </p>
                    <p class="help" v-if="saved == true">
                      {{ $t('app.messages.saved') }}
                    </p>
                    <p v-if="saved == false">
                      {{ $t('app.messages.failedSaving') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>

<script>
import { FooshiApi } from '@/services/fooshiApi.service'
import { EmailValidator } from '@/services/emailValidator.service'
import Modal from '@/components/Modal'
import PrimaryButton from '../components/forms/PrimaryButton.vue'

export default {
  components: {
    Modal,
    PrimaryButton
  },
  computed: {
    validPassword () {
      if (this.accountDetailsInfo.newPassword.length < 8) {
        return false
      }
      if (!/\d/.test(this.accountDetailsInfo.newPassword)) {
        return false
      }
      if (!/[a-z]/.test(this.accountDetailsInfo.newPassword)) {
        return false
      }
      if (!/[A-Z]/.test(this.accountDetailsInfo.newPassword)) {
        return false
      }
      if (!/[^0-9a-zA-Z]/.test(this.accountDetailsInfo.newPassword)) {
        return false
      }
      return true
    }
  },
  methods: {
    validateEmail () {
      if (EmailValidator.isValid(this.accountDetailsInfo.email)) {
        this.failureNotification = ''
      } else {
        this.failureNotification = 'onboarding.accountDetails.invalidEmailAddress'
      }
    },
    changeTab () {
      this.tabs.shopActive = !this.tabs.shopActive
      this.tabs.userActive = !this.tabs.userActive
    },
    showHidePassword () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
      this.showPassword = !this.showPassword
    },
    async submitShop () {
      this.submittingShop = true
      if (
        !this.accountDetailsInfo.email ||
        !this.accountDetailsInfo.minCart
      ) {
        this.errors = true
      } else {
        await this.updateShop()
      }
      this.submittingShop = false
    },
    async updateShop () {
      try {
        const response = await FooshiApi.updateVendor({
          vendorEmail: this.accountDetailsInfo.email,
          minCart: this.accountDetailsInfo.minCart,
          shipTime: this.accountDetailsInfo.shipTime
        })
        if (response.success) {
          this.saved = true
        } else {
          this.saved = false
        }
      } catch (err) {}
    },
    async getShopSettings () {
      var response = await FooshiApi.getVendor()
      if (response.status) {
        const data = response.data
        this.accountDetailsInfo.shopName = data.name
        this.accountDetailsInfo.email = data.vendorEmail
        this.accountDetailsInfo.minCart = data.minCart
        this.accountDetailsInfo.shipTime = data.shipTime
      }
    },
    async submitUser () {
      this.submittingUser = true
      if (
        !this.accountDetailsInfo.ownerName ||
        !this.accountDetailsInfo.ownerSurname ||
        !this.accountDetailsInfo.address ||
        !this.accountDetailsInfo.phone
      ) {
        this.errors = true
      } else {
        await this.updateUser()
      }
      this.submittingUser = false
    },
    async updateUser () {
      try {
        const response = await FooshiApi.updateUser({
          name: this.accountDetailsInfo.ownerName,
          surname: this.accountDetailsInfo.ownerSurname,
          address: this.accountDetailsInfo.address,
          phone: this.accountDetailsInfo.phone
        })
        if (response.success) {
          this.failureNotification = ''
          this.saved = true
        } else {
          this.failureNotification = response.message
          this.saved = false
        }
      } catch (err) {}
    },
    async getUserSettings () {
      var response = await FooshiApi.getUser()
      if (response.status) {
        const data = response.data
        this.accountDetailsInfo.ownerName = data.name
        this.accountDetailsInfo.ownerSurname = data.surname
        this.accountDetailsInfo.address = data.address
        this.accountDetailsInfo.phone = data.phone
      }
    },
    async changePassword () {
      try {
        var response = await FooshiApi.changePassword({
          oldPassword: this.accountDetailsInfo.oldPassword,
          newPassword: this.accountDetailsInfo.newPassword,
          repeatPassword: this.accountDetailsInfo.repeatPassword
        })
        if (response.success) {
          this.saved = true
        }
      } catch (err) {
        if (err.status === 404) {
          this.errors = true
          this.accountDetailsInfo.wrongCurrentPassword = true
        }
        this.saved = false
      }
    },
    async submitPassword () {
      this.submittingPassword = true
      if (
        !this.accountDetailsInfo.oldPassword ||
        !this.accountDetailsInfo.newPassword ||
        !this.accountDetailsInfo.repeatPassword ||
        this.accountDetailsInfo.newPassword !== this.accountDetailsInfo.repeatPassword ||
        !this.validPassword
      ) {
        this.errors = true
      } else {
        await this.changePassword()
      }
      this.submittingPassword = false
    },
    onLoginInfoChanged () {
      this.errors = false
    }
  },
  async mounted () {
    await this.getShopSettings()
    await this.getUserSettings()
  },
  data () {
    return {
      submittingShop: false,
      submittingUser: false,
      submittingPassword: false,
      errors: false,
      failureNotification: '',
      saved: null,
      passwordFieldType: 'password',
      showPassword: false,
      accountDetailsInfo: {
        email: '',
        minCart: '',
        shipTime: '',
        ownerName: '',
        ownerSurname: '',
        address: '',
        phone: '',
        newPassword: '',
        oldPassword: '',
        repeatPassword: '',
        wrongCurrentPassword: false
      },
      tabs: {
        shopActive: true,
        userActive: false
      }
    }
  }
}
</script>
<style>
is-hidden {
  display: none
}
</style>



// WEBPACK FOOTER //
// src/views/Settings.vue